import { Feedback } from "@bokio/designsystem/components/Feedback";
import { LoadingSpinner } from "@bokio/designsystem/components/Loading";
import { SG } from "@bokio/designsystem/components/SpacingGroup/SpacingGroup";
import { Paragraph } from "@bokio/designsystem/components/TypographicElements/TypographicElements";
import { GeneralLangFactory } from "@bokio/lang";

interface ProcessingBlockProps {
	message?: string;
}

export function ProcessingBlock({ message = "" }: ProcessingBlockProps) {
	const generalLang = GeneralLangFactory();
	return (
		<Feedback>
			<SG gap="16" align="center">
				<LoadingSpinner />
				<Paragraph testId="SveaOnboarding_Processing">{message ? message : `${generalLang.Processing}...`}</Paragraph>
			</SG>
		</Feedback>
	);
}
